import cookie from 'js-cookie'

export const localeMaps = {
  'en-US': 'English',
  'es-ES': 'Español',
  'de-DE': 'Deutsch',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  'fr-FR': 'Français',
  'pt-PT': 'Português',
  'jp-JP': '日本語',
  'ru-RU': 'Русский',
  'ko-KO': '한국어',
  'it-IT': 'Italiano',
  'vi-VN': 'Tiếng Việt',
  'pl-PL': 'Polski',
  'tr-TR': 'Türkçe',
  'id-ID': 'Bahasa Indonesia',
  'nl-NL': 'Nederlands',
  'sv-SE': 'Svenska'
}

export const localeKeys = Object.keys(localeMaps)

const langCookie = cookie.get('_zm_lang')
const langMap = {
  'en-US': ['en', 'uk', 'nl', 'au', 'ca', 'en_GB'],
  'zh-TW': ['zh_TW', 'zh_HK'],
  'zh-CN': ['zh', 'zh_CN'],
  'ru-RU': ['ru', 'ru_RU'],
  'pt-PT': ['pt', 'pt_BR', 'pt-BR'],
  'ko-KO': ['ko', 'ko-KR', 'ko_KR'],
  'jp-JP': ['jp', 'ja', 'ja-JP', 'ja_JP'],
  'fr-FR': ['fr', 'fr_FR'],
  'es-ES': ['es', 'es_ES'],
  'de-DE': ['de', 'de_DE']
}
function getLang(cookieValue) {
  let targetKey = 'en-US'
  for (const key in langMap) {
    if (langMap[key].indexOf(cookieValue) !== -1) {
      targetKey = key
      break
    }
  }
  return targetKey
}

export const locale = localeKeys.indexOf(langCookie) !== -1 ? langCookie : getLang(langCookie)

export const getUrlLanguageFlag = () => {
  const noChangeLanguages = ['zh-cn', 'zh-tw']

  if (noChangeLanguages.includes(locale.toLowerCase())) {
    return locale.toLowerCase()
  }
  const [prefix] = locale.split('-')
  return prefix
}

export const getContactSalesLink = () => {
  return `https://explore.zoom.us/${getUrlLanguageFlag()}/contactsales/`
}
